import axios from 'axios-es6'
import { captureMessage, captureException } from '@sentry/browser'
import { hookPartnersSite } from './_partners_hook'

function skipSentry(error) {
  if (!error.data || !error.request || !error.request.__sentry_xhr__) {
    return false
  }

  const { operation, errors } = error.data
  const { method, url, status_code } = error.request.__sentry_xhr__

  const requestToUnknownHost = () => {
    return url.slice(0, 5) !== '/api/'
  }

  const userTypedWrongOldPassword = () => {
    return method === 'PATCH'
      && url.includes('/api/user?locale=')
      && status_code === 422
      && operation === 'authenticate_user'
      && errors[0].internal_message === 'Password doesnt match.'
  }

  const activationCodeAlreadyInUse = () => {
    return method === 'POST'
      && url.includes('/api/simcards?locale=')
      && status_code === 423
      && error.data.error
      && error.data.error.toLowerCase().includes('activation code already in use')
  }

  const activationFailed = () => {
    return method === 'POST'
      && url.includes('/api/simcards?locale=')
      && status_code === 404
  }

  return requestToUnknownHost()
    || userTypedWrongOldPassword()
    || activationCodeAlreadyInUse()
    || activationFailed()
    || false
}

const createAxios = ({
  intl = null,
  timeout = 60000,
  makePartnersRedirect = true,
} = {}) => {
  const csrfToken = document.querySelector('meta[name=csrf-token]').content
  const instance = axios.create({
    baseURL: '/',
    timeout,
    withCredentials: true,
    headers: {
      'X-CSRF-Token': csrfToken,
    },
    validateStatus: status => status >= 200 && status < 300,
  })

  const start = () => { }
  const done = () => { }

  // Handle requests
  instance.interceptors.request.use((config) => {
    start()

    if (!/locale=\w+/.test(config.url)) {
      let locale

      switch(intl.locale) {
        case 'zh':
          locale = 'cn'
          break
        case 'ja':
          locale = 'jp'
          break
        default:
          locale = intl.locale
      }

      const delim = /\?/.test(config.url) ? '&' : '?'
      config.url = `${config.url}${delim}locale=${locale}`
    }

    return config
  })

  // Handle responses
  instance.interceptors.response.use((response) => {
    const hasContentType = typeof response.headers['content-type'] !== 'undefined'
    const isJSON = /application\/json/i.test(response.headers['content-type'])

    if (makePartnersRedirect) hookPartnersSite(response)

    if (hasContentType && !isJSON) {
      done()
      window.alertMessage(intl.formatMessage({ id: 'Axios.ServerError' }))
      return Promise.reject()
    }

    done()
    return response
  }, (error) => {
    done()
    const isError = error instanceof Error
    const { message, code } = error

    if (isError) {
      // Handle network errors (No internet connection)
      if (message === 'Network Error') {
        window.alertMessage(intl.formatMessage({ id: 'Axios.ConnectionError' }))
      // Handle timeout error
      } else if (code === 'ECONNABORTED') {
        window.alertMessage(intl.formatMessage({ id: 'Axios.TimeoutError' }))
      } else {
        captureException(error)
      }
    } else {
      const isJSON = () => {
      	const contentType = error && error.headers && error.headers['content-type']
      	return !!contentType && contentType.split(';').includes('application/json')
      }

      if (!isJSON()) {
        window.alertMessage(intl.formatMessage({ id: 'Axios.ConnectionError' }))
      } else if (!skipSentry(error)) {
        captureMessage(JSON.stringify(error.data))
      }
    }

    done()
    return Promise.reject(error)
  })

  return instance
}

export default createAxios



// WEBPACK FOOTER //
// ./app/javascript/utils/axios.js